import React from "react";

export const Footer = ({ c, isDark, setPage }) => (
  <footer style={{
    background: isDark ? c.surfaceContainerLowest : c.surfaceContainerLow,
    borderTop: `1px solid ${isDark ? "rgba(66,71,84,0.2)" : "rgba(0,0,0,0.06)"}`,
    padding: "60px 64px",
  }}>
    <div style={{
      maxWidth: 1280, margin: "0 auto",
      display: "flex", justifyContent: "space-between", alignItems: "center",
      flexWrap: "wrap", gap: 16,
    }}>
      <div style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 20, fontWeight: 900, color: c.primary, cursor: "pointer" }}
        onClick={() => setPage("Home")}>
        SYNTAX_ERR
      </div>
      <div style={{ display: "flex", gap: 32 }}>
        {["Github", "LinkedIn", "Twitter", "Terminal"].map((link) => (
          <a key={link} href="#" style={{
            fontFamily: "'JetBrains Mono', monospace", fontSize: 12,
            color: c.onTertiaryFixedVariant, textDecoration: "none",
            transition: "color 0.2s",
          }}
            onMouseEnter={e => e.target.style.color = c.secondary}
            onMouseLeave={e => e.target.style.color = c.onTertiaryFixedVariant}
          >{link}</a>
        ))}
      </div>
      <p style={{ fontFamily: "'JetBrains Mono', monospace", fontSize: 12, color: c.onTertiaryFixedVariant }}>
        © 2024 SYNTAX_ERR. ENGINEERED FOR SCALE.
      </p>
    </div>
  </footer>
);